import { Link, useLocation } from "react-router-dom";
import style from "./style.module.scss";

function ExplorePair({ page, text }) {
  console.log({ text });
  return (
    <div className={style.ExplorePair + " row"}>
      <Part
        data={text && text[page]?.explorepair?.left}
        page={page}
        part={"left"}
      />
      <Part
        data={text && text[page]?.explorepair?.right}
        page={page}
        part={"right"}
      />
    </div>
  );
}

function Part({ data, page, part }) {
  const location = useLocation();

  return data ? (
    <div className={style.part}>
      <div
        className={style.image}
        style={{
          backgroundImage: `url("Images/infopages/common/explorepair/${data.name}.webp")`,
        }}
      ></div>
      <div className={style.content}>
        <div className={style.box}>
          <div className={style.title + " title-font"}>{data.title}</div>
          <div className={style.text}>{data.text}</div>
          <Link
            to={"events/" + page + "/" + part}
            style={{ textDecoration: "none" }}
          >
            <div
              className={style.button}
              // onClick={() =>
              //   document.querySelector(".brancoscrolltarget").scrollIntoView()
              // }
            >
              {data.button}
            </div>
          </Link>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default ExplorePair;
